import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AccessDeniedComponent } from './access-denied.component';

@NgModule({
  declarations: [
    AccessDeniedComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
  ],
  exports: [
    AccessDeniedComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccessDeniedModule { }
